module.exports = __webpack_public_path__ + "img/emoji_04.7274adf3.png";